export enum UsersViewTitles {
    Users = 'Users',
    InviteUsers = 'Invite Users',
    InviteUsersViaEmail = 'Invite Users via Email',
    InviteUsersViaCSV = 'Invite Users via CSV',
}
